"use client"

import { Button } from "@medusajs/ui"
import { useEffect, useState, useCallback } from "react"
import { FaArrowUp } from "react-icons/fa"
import { throttle } from "@/lib/utils"
import { cn } from "@/lib/utils"

const SCROLL_THRESHOLD = 300
const THROTTLE_TIME = 200

const useBackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = useCallback(() => {
    if (window.pageYOffset > SCROLL_THRESHOLD) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [])

  useEffect(() => {
    const throttledToggleVisibility = throttle(toggleVisibility, THROTTLE_TIME, {
      trailing: true,
    })
    window.addEventListener("scroll", throttledToggleVisibility)

    return () => {
      window.removeEventListener("scroll", throttledToggleVisibility)
    }
  }, [toggleVisibility])

  return isVisible
}

export const BackToTopButton = () => {
  const isVisible = useBackToTop()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <Button
      className={cn(
        "fixed bottom-10 right-10 bg-primary text-black rounded-full p-3 shadow-lg transition-opacity duration-300 border-2 border-black",
        {
          "opacity-100": isVisible,
          "opacity-0": !isVisible,
        }
      )}
      onClick={scrollToTop}
      style={{ zIndex: 1 }}
      aria-label="Back to top"
    >
      <FaArrowUp />
    </Button>
  )
}